import { useQuery } from '@tanstack/react-query';
import ReportAPI from 'apis/ReportAPI';
import { normalizeId } from '../utils/idNormalization';

// Define query keys for code reports
export const codeReportKeys = {
  all: ['code-reports'],
  details: () => [...codeReportKeys.all, 'detail'],
  detail: (codeId) => [...codeReportKeys.details(), normalizeId(codeId)],
};

/**
 * Hook to fetch code report data by code ID
 * @param {string|number} codeId - The ID of the code to fetch report for
 * @returns {Object} The query result containing code report data, loading state, and error
 */
export function useCodeReport(codeId) {
  const normalizedCodeId = normalizeId(codeId);
  
  return useQuery({
    queryKey: codeReportKeys.detail(normalizedCodeId),
    queryFn: () => ReportAPI.getCodeReport(codeId)
      .then(response => response.data),
    enabled: !!codeId,
  });
}